import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero" aria-label="Hauptbereich - Ihr Reinigungspartner in Berlin">
      <div className="hero-text">
        <h1>
          Ihr Reinigungspartner <br /> in <span className="blue">Berlin</span>
        </h1>
        <p>
          Eine Reinigungsfirma, die Ihnen im gesamten Umkreis von Berlin zur
          Verfügung steht.
          <br />
          Mit uns können Sie sich auf Ihr Kerngeschäft konzentrieren, und wir
          sorgen für die richtige Atmosphäre.
        </p>
        <button
          className="cta-btn"
          onClick={() => {
            const section = document.getElementById("kontakt");
            if (section) {
              section.scrollIntoView({ behavior: "smooth" });
            }
          }}
          aria-label="Kostenloses Angebot anfordern - Springe zum Kontaktformular"
        >
          Angebot Anfordern
        </button>
      </div>
    </section>
  );
};

export default Hero;
